import { Routes } from '@angular/router';
import { ErrorComponent } from './layout/components/error/error.component';
import { AuthGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';
import { ModeGuard } from './core/guards/mode-dev.guard';

export const routes: Routes = [
    //  {
    //     path:'',
    //     pathMatch:'full',
    //     redirectTo:''
    //  },
    {
        path: 'design',
        loadChildren: () => import('./modules/design/design.module').then(m => m.DesignModule),
        canActivate: [ModeGuard]
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
        canActivate:[loginGuard]
    },
    {
        path: '',
        loadChildren: () => import('./layout/modules/master/master.module').then(m => m.MasterModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'error/:title/:message/:icon',
        component: ErrorComponent
    }
];
